import styled, { css } from 'styled-components';
import { device } from '../../styles/devices';
import { SIZING, COLORS } from '../../styles/variables';

interface CopyNotesStyleProps {
  sticky?: boolean;
}

interface ButtonStyleProps {
  type: 'primary' | 'secondary' | 'disabled';
  sticky?: boolean;
  isAvailableNow?: boolean;
  isAdjustMarginRight?: boolean;
}

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  font-family: 'Audi Type';
  margin-top: ${SIZING.unit(3)};
  @media ${device.mobileL} {
    flex-wrap: wrap;
  }
  @media ${device.tablet} {
    flex: 1;
  }
  @media ${device.laptopM} {
    justify-content: center;
    max-width: 650px;
  }
`;

export const ButtonsContainer = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  gap: 8px;
  @media ${device.mobileL} {
    flex-direction: ${({ sticky }: CopyNotesStyleProps) => (sticky ? 'row' : 'column')};
  }
  @media ${device.tablet} {
    flex-direction: ${({ sticky }: CopyNotesStyleProps) => (sticky ? 'row' : 'column')};
    justify-content: flex-end;
  }
  @media ${device.laptop} {
    flex-direction: row;
    justify-content: flex-end;
  }
`;

export const CtaButton = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 6px 0 0;
  height: ${({ sticky }: ButtonStyleProps) => (sticky ? '46px' : '56px')};
  z-index: 10;
  cursor: pointer;
  text-align: center;
  line-height: 24px;
  letter-spacing: 0.003px;
  font-weight: 400;
  font-size: ${({ sticky }: ButtonStyleProps) => (sticky ? '12px' : '16px')};
  width: 100%;
  min-width: 195px;
  padding: ${SIZING.unit(1)};
  ${({ type, sticky, isAdjustMarginRight }: ButtonStyleProps) => {
    if (type === 'primary')
      return css`
        background: ${sticky ? COLORS.white : COLORS.black};
        color: ${sticky ? COLORS.black : COLORS.white};
        border: ${sticky ? `1px solid ${COLORS.white} ` : `1px solid ${COLORS.black}`};
        @media ${device.tablet} {
          margin-right: ${sticky ? '' : '0'};
        }
        @media ${device.laptop} {
          margin-right: ${sticky ? '' : SIZING.unit(0.5)};
          margin-right: ${isAdjustMarginRight ? '0px' : ''};
        }
      `;
    if (type === 'secondary')
      return css`
        background: transparent;
        color: ${sticky ? COLORS.white : COLORS.black};
        border: ${sticky ? `1px solid ${COLORS.white} ` : `1px solid ${COLORS.black}`};
        margin-right: ${sticky ? '' : '0'};
        @media ${device.laptop} {
          margin-right: ${isAdjustMarginRight ? SIZING.unit(0.5) : ''};
        }
      `;
    if (type === 'disabled')
      return css`
        background: ${COLORS.grey30};
        color: #ffffff;
        border: 1px solid ${COLORS.grey30};
        cursor: default;
      `;
    return css`
      border: 1px solid ${COLORS.black};
    `;
  }}
  @media ${device.tablet} {
    height: ${({ sticky }: ButtonStyleProps) => (sticky ? '58px' : '56px')};
    width: ${({ sticky }: ButtonStyleProps) => (sticky ? '195px' : 'unset')};
  }
  @media ${device.laptop} {
    font-size: 16px;
    width: ${({ sticky }: ButtonStyleProps) => (sticky ? '300px' : 'unset')};
    padding: ${({ sticky }: ButtonStyleProps) =>
      sticky ? '' : `${SIZING.unit(2)} ${SIZING.unit(4)}`};
  }
  @media ${device.laptopM} {
    width: ${({ sticky }: ButtonStyleProps) => (sticky ? '330px' : 'unset')};
  }
`;

export const CopyNotes = styled.div`
  font-family: 'Audi Type';
  color: ${({ sticky }: CopyNotesStyleProps) => {
    return sticky ? COLORS.grey15 : COLORS.grey60;
  }};
  line-height: ${({ sticky }) => (sticky ? '13px' : '20px')};
  font-size: ${({ sticky }) => (sticky ? '10px' : '12px')};
  padding: ${SIZING.unit(1)} 0;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
`;

export const OnlineShoppingNoteWrapper = styled.div`
  color: ${COLORS.grey50};
  @media ${device.laptop} {
    margin-top: 12px;
  }
  a {
    text-decoration: underline;
    color: ${COLORS.grey50};
  }
`;

export const CopyNotesLaptopWrapper = styled.div`
  position: absolute;
  top: 56px;
`;

export const HowEDepositWorks = styled.div`
  @media ${device.tablet} {
    max-width: 640px;
  }
  button {
    border: none;
    background: inherit;
    padding: 0;
    font-weight: 700;
    font-size: 12px;
    font-family: 'Audi Type';
    color: ${COLORS.grey60};
    border-bottom: 1px solid ${COLORS.grey60};
    padding-bottom: 5px;
    cursor: pointer;
  }
`;
